import React, { useState, useEffect, useMemo } from "react";
import Slider from "react-slick";
import axios from "axios";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import airlines from "../data/airlines.json";
import airportsData from '../data/airports.json';


function FlightDetailDestination() {

  const phoneNumber = "+923454362491";

  // Toggle function for flight details
  const [openFlightIndex, setOpenFlightIndex] = useState(null); // Track state for each flight

  // Toggle function for flight details visibility
  const toggleDetails = (index) => {
    setOpenFlightIndex((prevIndex) => (prevIndex === index ? null : index)); // Close if same flight is clicked again
  };

  const [token, setToken] = useState("");
  const [flights, setFlights] = useState([]);
  const [loading, setLoading] = useState(true);
  const { search } = useLocation();

  // Function to get the airline name by code
  const getAirlineName = (code) => {
    const airline = airlines.find((airline) => airline.code === code);
    return airline ? airline.name : "Unknown Airline";
  };

  // Define the date formatting function BEFORE using it
  const formatDate = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  };

  const formatDsiplayDate = (dateStr) => {
    const date = new Date(dateStr);
    // Get the day, month, and year
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-GB", { month: "short" }); // e.g., "Oct"
    const year = date.getFullYear();

    // Construct the formatted date string
    return `${day} ${month}, ${year}`;
  };

  const extractTime = (timestamp) => {
    const date = new Date(timestamp);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const formatDuration = (duration) => {
    const regex = /PT(\d+H)?(\d+M)?/; // Regex to extract hours and minutes
    const match = duration.match(regex);

    const hours = match[1] ? match[1].replace("H", "") : "0";
    const minutes = match[2] ? match[2].replace("M", "") : "0";

    return `${hours}h ${minutes}min`;
  };


  {/*Destination Page values Start*/}
  const { 'from-to': fromTo } = useParams(); // Access the combined parameter
  let toAirport, startDateDestination, EndDateDestination,startDate, endDate  = '';

  if (fromTo) {
      // Split the parameter to get from and to
      const [from, to] = fromTo.split('-to-');
      //Get Airport Code By City
      const getAirportCodeByCity = (city) => {
          const airport = airportsData.find(airport => airport.name.includes(city));
          return airport ? airport.code : 'Airport code not found';
      };
      toAirport = getAirportCodeByCity(to.replace(/-/g, ' '));
      localStorage.setItem('destination', toAirport);
      // Helper function to format dates as DD-MM-YYYY
      const formatDestinationDate = (date) => {
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
          const year = date.getFullYear();
          return `${year}-${month}-${day}`;
      };

      // Calculate the start date (3 days from the current date)
      const currentDate = new Date();
      const startDate = new Date(currentDate);
      startDate.setDate(currentDate.getDate() + 3);
      startDateDestination = formatDestinationDate(startDate);

      // Calculate the return date (10 days after the start date)
      const returnDate = new Date(startDate);
      returnDate.setDate(startDate.getDate() + 10);
      EndDateDestination = formatDestinationDate(returnDate);

  }
  {/*Destination Page values End*/}

  // Extract query parameters from the URL
  const queryParams = new URLSearchParams(window.location.search);
  const origin = queryParams.get("origin") || "LHR";
  const destination = queryParams.get("destination") || toAirport;
  const tripType = queryParams.get("tripType") || 'Round Trip'; // e.g., 'one-way' or 'round-trip'
  
  if (fromTo) {
    startDate = startDateDestination;
    endDate = EndDateDestination;
  }else{
    startDate = formatDate(queryParams.get("startDate"));
    endDate = queryParams.get("endDate")
      ? formatDate(queryParams.get("endDate"))
      : null;
  }
  const adults = queryParams.get("adults") || 1;
  const children = queryParams.get("children") || 0;
  const infants = queryParams.get("infants") || 0;
  const name = queryParams.get("name");
  const email = queryParams.get("email");
  const phone = queryParams.get("phone");


  // Construct the API URL dynamically based on query parameters
  const apiUrl = `https://test.api.amadeus.com/v2/shopping/flight-offers?originLocationCode=${origin}&destinationLocationCode=${destination}&departureDate=${startDate}&adults=${adults}&children=${children}&infants=${infants}&travelClass=ECONOMY&nonStop=false&currencyCode=GBP&max=35${
    tripType === "Round Trip" ? `&returnDate=${endDate}` : ""
  }`;

  // Step 1: Fetch Access Token (Once on Mount)
  useEffect(() => {
    const getAccessToken = async () => {
      try {
        const response = await axios.post(
          "https://test.api.amadeus.com/v1/security/oauth2/token",
          new URLSearchParams({
            grant_type: "client_credentials",
            client_id: "ME9mKYMWwxzf3JI02aTa5bHDh8DgLZXo",
            client_secret: "M9QzUQhuxMAXstqK",
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        );

        setToken(response.data.access_token);
      } catch (error) {
        //console.error("Error fetching token:", error);
      }
    };

    getAccessToken(); // Call only once on mount
  }, []); // Empty dependency to run only on initial render

  // Step 2: Fetch Flight Offers (Only After Token Is Ready)
  useEffect(() => {
    if (!token) return; // Prevent fetching without token
    window.scrollTo(0, 0);
    const fetchFlightOffers = async () => {
      try {
        setLoading(true);
        setFlights([]);
        const response = await axios.get(apiUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });
        //console.log("Flight Data:", response.data); // Single call, no double log
        setFlights(response.data.data || []);
      } catch (error) {
        //console.error("Error fetching flight offers:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFlightOffers(); // Triggered only once after token is set
  }, [token, apiUrl]); // Run when token changes

  {
    /*Horizontal Arrow*/
  }
  const FlightStopsArrowHorizontal = (totalStopss) => {
    return (
      <div>
        <div className="TransportTimeline__LineWrapper">
          <div className="TransportTimeline__Line"></div>
          <div className="TransportTimeline__Triangle"></div>
          <div className="TransportTimeline__Dots">
            {Array.from({ length: totalStopss }).map((_, index) => (
              <div className="TransportTimeline__Dot"></div>
            ))}
          </div>
        </div>
        <small className="stops-text">
          {totalStopss === 0
            ? "Direct"
            : `${totalStopss} ${totalStopss === 1 ? "stop" : "stops"}`}
        </small>
      </div>
    );
  };

  {/*AIrline Filter Function*/}
  const filteredAirlines = useMemo(() => {
    const airlineData = flights
      .flatMap((flight) => {
        const itineraries = flight.itineraries;
        const segments = itineraries.flatMap((itinerary) => itinerary.segments || []);
        const carrierCodes = segments.map((segment) => segment.carrierCode);
        const price = flight.price?.total || 0; // Adjust this based on your flight object structure
        return carrierCodes.map((code) => ({
          airlineName: getAirlineName(code),
          airlineCode: code,
          price: parseFloat(price), // Ensure price is treated as a number
        }));
      });

    // Remove duplicates based on airlineName and keep the lowest price
    const airlineMap = new Map();

    airlineData.forEach((item) => {
      if (!airlineMap.has(item.airlineName)) {
        airlineMap.set(item.airlineName, item);
      } else {
        const existingItem = airlineMap.get(item.airlineName);
        if (item.price < existingItem.price) {
          airlineMap.set(item.airlineName, item); // Update with the lower price
        }
      }
    });

    // Convert the Map back to an array
    return Array.from(airlineMap.values());
  }, [flights]);

  
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
         {
             breakpoint: 500,
             settings: {
                 slidesToShow: 2
             }
         }]
  };

  /*Booking FUnction*/
  const navigate = useNavigate();
  const handleInquireClick = (selectedFlight) => {
    // Navigate to the booking page and pass selected flight details as state

    localStorage.setItem("selectedFlightairline", getAirlineName(selectedFlight.validatingAirlineCodes[0]));
    localStorage.setItem("selectedFlightPrice", selectedFlight.price.total);
    localStorage.setItem("selectedFlight", JSON.stringify(selectedFlight));

    navigate('/booking-destination', { state: { selectedFlight } });
  };

  // Function to get the airport name by code
  const getAirportName = (code) => {
    const airport = airportsData.find(airport => airport.code === code);
    return airport ? airport.name : 'Airport not found';
  };

  const handleShare = () => {
    const currentUrl = window.location.href; // Get the current URL
    const message = `Check this out: ${currentUrl}`; // Message to share
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;

    // Open the WhatsApp share link
    window.open(whatsappUrl, "_blank");
  };

  return (
    <>
      {/* top Destination starts */}
      <section className="resultsSections pt-1 pb-5">
        <div className="container">
          {loading ? (
            <div className="text-center loadingIcon">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/loader.gif`}
                alt="loader"
              />
            </div>
          ) : (
            
               
            
            <div className="row">
                
                  <Slider {...settings} className="side-slider">
                    {filteredAirlines.map((airline, index) => (
                        <div className="col-lg-3 col-md-6 my-4">
                            <a href="tel:+447954981818" >
                              <div className="category-item box-shadow p-3 py-2 text-center bg-white rounded overflow-hidden">
                                  <div className="trending-topic-content">
                                      <img src={`${process.env.PUBLIC_URL}/assets/images/airline/${airline.airlineCode}.png`} className="mb-1 d-inline-block" alt="" />
                                      <p style={{ fontSize: "16px", color: "#333", fontWeight:"700", textAlign:"center" }} >{airline.airlineName}</p>
                                      <p style={{ fontSize: "16px", color: "#333", fontWeight:"700", textAlign:"center" }}>
                                      £{airline.price}
                                      </p>
                                  </div>
                              </div>
                            </a>
                        </div>
                    ))}
                  </Slider>
                
              <div className="col-lg-3 ps-lg-2 hidden-mobile">
                <div className="sidebar-sticky">
                  <div className="list-sidebar">
                    <div className="sidebar-item bg-white rounded box-shadow overflow-hidden p-3 mb-4">
                            <h4>Why booking with us?</h4>
                            <div className="sidebar-module-inner">
                                <ul className="featured-list-sm">
                                    <li className="border-b pb-2 mb-2">
                                        <h6 className="mb-0">No Booking Charges</h6>
                                        We don't charge you an extra fee for booking a hotel room with us
                                    </li>
                                    <li className="border-b pb-2 mb-2">
                                        <h6 className="mb-0">No Cancellation Sees</h6>
                                        We don't charge you a cancellation or modification fee in case plans change
                                    </li>
                                    <li className="border-b pb-2 mb-2">
                                        <h6 className="mb-0">Instant Confirmation</h6>
                                        Instant booking confirmation whether booking online or via the telephone
                                    </li>
                                    <li>
                                        <h6 className="mb-0">Flexible Booking</h6>
                                        You can book up to a whole year in advance or right up until the moment of your stay
                                    </li>
                                </ul>
                            </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-9">
                <div className="flight-list">
                  <div className="flight-full">
                    {flights.map((flight, flightIndex) => {
                      // Group traveler pricings by type inside each flight
                      const groupedTravelerPricings =
                        flight.travelerPricings.reduce((acc, traveler) => {
                          const type =
                            traveler.travelerType === "HELD_INFANT"
                              ? "Infant"
                              : traveler.travelerType; // Replace "HELD_INFANT" with "Infant"

                          if (!acc[type]) {
                            acc[type] = { quantity: 0, totalPrice: 0 };
                          }

                          acc[type].quantity += traveler.quantity || 1; // Sum quantities
                          acc[type].totalPrice += parseFloat(
                            traveler.price.total
                          ); // Sum prices

                          return acc;
                        }, {});

                      // Initialize a variable to collect segment details during the itinerary loop
                      let segmentDetails = [];
                      return (
                        <div
                          key={flightIndex}
                          className="flightRow item mb-2 p-3 px-4 rounded"
                        >
                          <div className="row d-flex align-items-center justify-content-between">
                            <div className="col-lg-10">
                              {flight.itineraries.map(
                                (itinerary, itineraryIndex) => {
                                  //Total Stops Calculate
                                  const segments = itinerary.segments;
                                  const totalStops = segments.length - 1; // Number of stops is one less than the number of segments

                                  // Extract start and end times for each itinerary
                                  const firstSegment = itinerary.segments[0];
                                  const lastSegment =
                                    itinerary.segments[
                                      itinerary.segments.length - 1
                                    ];
                                  const startTime = extractTime(
                                    firstSegment.departure.at
                                  );
                                  const endTime = extractTime(
                                    lastSegment.arrival.at
                                  );
                                  const startDate = formatDsiplayDate(
                                    firstSegment.departure.at
                                  );
                                  const EndDate = formatDsiplayDate(
                                    lastSegment.arrival.at
                                  );
                                  const duration = formatDuration(
                                    itinerary.duration
                                  );

                                  //Origin Destination Names
                                  const originName =
                                    firstSegment.departure.iataCode;
                                  const destinationName =
                                    lastSegment.arrival.iataCode;

                                  // Airline details for the first segment of each itinerary
                                  const airlineCode = firstSegment.carrierCode;
                                  const airlineName =
                                    getAirlineName(airlineCode);
                                  const flightNumber = firstSegment.number;

                                 
                                  return (
                                    <div
                                      className="row text-center itry"
                                      key={itineraryIndex}
                                    >
                                      <div className="col-lg-4 itryAirline">
                                        <div className="item-inner-image">
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/airline/${airlineCode}.png`}
                                            alt="image"
                                            className="resultPlane"
                                          />
                                          <h5 className="mb-0 airlineName">
                                            {airlineName}
                                          </h5>
                                          <small>
                                            {airlineCode} {flightNumber}
                                          </small>
                                        </div>
                                      </div>

                                      <div className="col-lg-3 itryFlightTime">
                                        <div className="item-inner">
                                          <div className="content">
                                            <h3 className="mb-0 flightTime">
                                              {startTime}
                                            </h3>
                                            <small className="mb-0 text-uppercase">
                                              {originName}
                                            </small>
                                            <br />
                                            <small className="mb-0 text-uppercase">
                                              {startDate}
                                            </small>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-2 itryFlightDuration">
                                        <div className="item-inner flight-time">
                                          <small className="mb-0">
                                            {duration}
                                          </small>
                                          <br />
                                          {FlightStopsArrowHorizontal(
                                            totalStops
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-3 itryFlightTime">
                                        <div className="item-inner">
                                          <div className="content">
                                            <h3 className="mb-0 flightTime">
                                              {endTime}
                                            </h3>
                                            <small className="mb-0 text-uppercase">
                                              {destinationName}
                                            </small>
                                            <br />
                                            <small className="mb-0 text-uppercase">
                                              {EndDate}
                                            </small>
                                          </div>
                                        </div>
                                      </div>
                                      {itineraryIndex === 0 && (
                                        <div
                                          className="border-t"
                                          style={{ margin: "10px 0" }}
                                        ></div>
                                      )}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-12">
                              <div className="item-inner text-end">
                                <p className="theme2 fs-4 fw-bold">
                                  £{flight.price.total}
                                </p>

                                <div>
                                  {Object.entries(groupedTravelerPricings).map(
                                    (
                                      [type, { quantity, totalPrice }],
                                      index
                                    ) => (
                                      <small
                                        className="priceBreakDown"
                                        key={index}
                                      >
                                        {quantity} X {type}
                                        {quantity > 1 ? "s" : ""} = £
                                        {totalPrice.toFixed(2)}
                                      </small>
                                    )
                                  )}
                                </div>
                                <br />
                                
                                <button  onClick={() => handleInquireClick(flight)} className="nir-btn-black inquireBtn">Inquire Now</button>

                                {/* Buttons */}
                                <div className="flight-actions">
                                  
                                  {/* Share Button */}
                                  
                                  <button
                                    onClick={() => {
                                      const shareText = `Check this out: `;
                                      if (navigator.share) {
                                        navigator.share({
                                          title: "Flight Details",
                                          text: shareText,
                                          url: window.location.href, // You can replace this with a flight-specific URL
                                        });
                                      } else {
                                        alert("Sharing not supported on this browser.");
                                      }
                                    }}
                                    className="action-button share-button"
                                  >
                                    <i className="fas fa-share-alt"></i>
                                  </button>

                                  {/* WhatsApp Button */}
                                  <a
                                    href={`https://wa.me/${phoneNumber}?text=I'm interested in this flight: ${getAirportName(origin)} - ${getAirportName(destination)}, Date: ${startDate} - ${endDate}, Airline: ${getAirlineName(flight.validatingAirlineCodes[0])}, Price: £${flight.price?.total}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="action-button whatsapp-button"
                                  >
                                    <i className="fab fa-whatsapp"></i>
                                  </a>

                                  {/* Call Button */}
                                  <a href={`tel:${phoneNumber}`} className="action-button call-button">
                                    <i className="fas fa-phone"></i>
                                  </a>

                                </div> 

                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-4"></div>
                            <div className="col-lg-4 text-center">
                             </div>
                          </div>
                          
                        </div>
                      );
                    })}
                  </div>
                  {/*<div className="flight-btn text-center"><a href="#" className="nir-btn">Load More</a></div>*/}
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
      {/* top Destination ends */}
    </>
  );
}
export default FlightDetailDestination;
